"use client";
//#region packages/@mantine/core/src/components/ScrollArea/utils/is-scrolling-within-scrollbar-bounds.ts
function isScrollingWithinScrollbarBounds(scrollPos, maxScrollPos) {
	return scrollPos > 0 && scrollPos < maxScrollPos;
}
//#endregion
export { isScrollingWithinScrollbarBounds };

//# sourceMappingURL=is-scrolling-within-scrollbar-bounds.mjs.map